import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from '@apollo/react-hooks';
import * as actions from '../store/actions';
import * as selectors from '../store/selectors';
import {
  UpdateFilterGroupDocument as updateGroupQuery,
  UpdateFilterGroupMutation as updateGroupResult,
  UpdateFilterGroupMutationVariables as updateGroupVars,
} from 'generated/favorites-graphql';
import { favGroupsClient } from 'apollo';
import {
  clientIdSelector,
  currentBrandSelector,
  isEnterpriseContextSelector,
} from 'store/global/selectors';
import { CONTEXT, SelectionType } from 'utils/types';
import { selectionSelector } from 'components/FilterModal/store/selectors';
import * as filterActions from 'components/FilterModal/store/actions';
import SaveButton from 'components/Buttons/SaveButton';

interface Props {
  isDisabledSaveButton?: boolean;
  storesRefecth: () => void;
  itemsRefecth: () => void;
}

const UpdateGroupAction: React.FC<Props> = ({
  isDisabledSaveButton,
  storesRefecth,
  itemsRefecth,
}) => {
  const clientId = useSelector<string>(clientIdSelector);
  const currentBrand = useSelector<string>(currentBrandSelector);
  const isEnterpriseContext = useSelector<boolean>(isEnterpriseContextSelector);
  const groupName = useSelector<string>(selectors.groupNameSelector);
  const groupType = useSelector<string>(selectors.groupTypeSelector);

  // Get data from Filter Modal Store
  const selection = useSelector<SelectionType>(selectionSelector);
  const groupId = useSelector<string>(selectors.groupIdSelector);
  const dispatch = useDispatch();

  const handleUpdate = (updateGroupMutation) => {
    updateGroupMutation({
      variables: {
        clientID: clientId,
        id: groupId,
        input: {
          context: `${CONTEXT}-${groupType}-group`,
          name: groupName,
          data: {
            accounts: selection.accounts?.map((item) => item.id),
            stores: selection.stores?.map((item) => item.id),
            states: selection.states?.map((item) => item.id),
            items: selection.items?.map((item) => item.id),
            ...(isEnterpriseContext && { brand: currentBrand }),
          },
        },
      },
    });
  };

  const onUpdateSuccess = () => {
    dispatch(actions.setShow(false));
    dispatch(actions.resetModal());
    dispatch(filterActions.clearSelections());
  };

  const [updateGroup, { loading, error }] = useMutation<updateGroupResult, updateGroupVars>(
    updateGroupQuery,
    {
      client: favGroupsClient as any,
      onCompleted: (data) => {
        onUpdateSuccess();
        storesRefecth();
        itemsRefecth();
      },
      onError: () => {
        console.log('error', error);
      },
    }
  );

  return (
    <SaveButton
      loading={loading}
      onClick={() => handleUpdate(updateGroup)}
      isDisabled={isDisabledSaveButton}
    />
  );
};

export default UpdateGroupAction;
